import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { getDiscountPrice } from "../../../helpers/product";
import { removeFromWishlist, removeAllFromWishlist } from "../../../redux/actions/wishlistActions";
import { addToCart } from "../../../redux/actions/cartActions";
import { buildDynamicLinkForRef, constructArtificialLinkNode, getStaticPageLink } from "../../../utils/links";
import { decodeText } from "../../../utils/richText";
import Breadcrumb from "../../../components/magnolia/breadcrumb/Breadcrumb";
import HtmlHeader from "../../../components/magnolia/htmlHeader/HtmlHeader";
import Image from "../../../components/magnolia/image/Image";
import LinkWrapper from "../../../components/magnolia/linkWrapper/LinkWrapper";

// Magnolia twin of flone's pages/other/Wishlist. It renders inside BaseLayout, which already
// provides the shop's header and footer, so there is no LayoutOne here (that gave the page a
// second, flone-branded header). Product links, images and names follow the Cart page.
const Wishlist = ({ cartItems, wishlistItems, currency, addToCart, removeFromWishlist, removeAllFromWishlist }) => {
    const shopLink = constructArtificialLinkNode({ value: getStaticPageLink("HOME") });

    return (
        <Fragment>
            <HtmlHeader title="Wishlist" />
            <Breadcrumb />

            <div className="cart-main-area pt-90 pb-100">
                <div className="container">
                    {wishlistItems && wishlistItems.length >= 1 ? (
                        <Fragment>
                            <h3 className="cart-page-title">Your wishlist items</h3>
                            <div className="row">
                                <div className="col-12">
                                    <div className="table-content table-responsive cart-table-content">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Image</th>
                                                    <th>Product Name</th>
                                                    <th>Unit Price</th>
                                                    <th>Add To Cart</th>
                                                    <th>action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {wishlistItems.map((wishlistItem, key) => {
                                                    const discountedPrice = getDiscountPrice(wishlistItem.price, wishlistItem.discount);
                                                    const finalProductPrice = (wishlistItem.price * currency.currencyRate).toFixed(2);
                                                    const finalDiscountedPrice = (discountedPrice * currency.currencyRate).toFixed(2);
                                                    const cartItem = cartItems.filter((item) => item.id === wishlistItem.id)[0];
                                                    const productLinkNode = constructArtificialLinkNode({
                                                        value: buildDynamicLinkForRef("PRODUCT_DETAIL", wishlistItem),
                                                    });

                                                    return (
                                                        <tr key={key}>
                                                            <td className="product-thumbnail">
                                                                {wishlistItem.image && wishlistItem.image[0] && (
                                                                    <LinkWrapper linkNode={productLinkNode}>
                                                                        <Image imageNode={wishlistItem.image[0]} className="img-fluid" />
                                                                    </LinkWrapper>
                                                                )}
                                                            </td>

                                                            <td className="product-name text-center">
                                                                <LinkWrapper linkNode={productLinkNode}>{decodeText(wishlistItem.displayName)}</LinkWrapper>
                                                            </td>

                                                            <td className="product-price-cart">
                                                                {discountedPrice !== null ? (
                                                                    <Fragment>
                                                                        <span className="amount old">{currency.currencySymbol + finalProductPrice}</span>
                                                                        <span className="amount">{currency.currencySymbol + finalDiscountedPrice}</span>
                                                                    </Fragment>
                                                                ) : (
                                                                    <span className="amount">{currency.currencySymbol + finalProductPrice}</span>
                                                                )}
                                                            </td>

                                                            <td className="product-wishlist-cart">
                                                                {wishlistItem.affiliateLink ? (
                                                                    <a href={wishlistItem.affiliateLink} rel="noopener noreferrer" target="_blank">
                                                                        {" "}
                                                                        Buy now{" "}
                                                                    </a>
                                                                ) : wishlistItem.variation && wishlistItem.variation["@nodes"].length >= 1 ? (
                                                                    <LinkWrapper linkNode={productLinkNode}>Select option</LinkWrapper>
                                                                ) : wishlistItem.stock && wishlistItem.stock > 0 ? (
                                                                    <button
                                                                        onClick={() => addToCart(wishlistItem)}
                                                                        className={cartItem !== undefined && cartItem.quantity > 0 ? "active" : ""}
                                                                        disabled={cartItem !== undefined && cartItem.quantity > 0}
                                                                        title={cartItem !== undefined ? "Added to cart" : "Add to cart"}
                                                                    >
                                                                        {cartItem !== undefined && cartItem.quantity > 0 ? "Added" : "Add to cart"}
                                                                    </button>
                                                                ) : (
                                                                    <button disabled className="active">
                                                                        Out of stock
                                                                    </button>
                                                                )}
                                                            </td>

                                                            <td className="product-remove">
                                                                <button onClick={() => removeFromWishlist(wishlistItem)}>
                                                                    <i className="fa fa-times"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="cart-shiping-update-wrapper">
                                        <div className="cart-shiping-update">
                                            <LinkWrapper linkNode={shopLink}>Continue Shopping</LinkWrapper>
                                        </div>
                                        <div className="cart-clear">
                                            <button onClick={() => removeAllFromWishlist()}>Clear Wishlist</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    ) : (
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="item-empty-area text-center">
                                    <div className="item-empty-area__icon mb-30">
                                        <i className="pe-7s-like"></i>
                                    </div>
                                    <div className="item-empty-area__text">
                                        No items found in wishlist <br />{" "}
                                        <LinkWrapper linkNode={shopLink}>Add Items</LinkWrapper>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

Wishlist.propTypes = {
    addToCart: PropTypes.func,
    cartItems: PropTypes.array,
    currency: PropTypes.object,
    removeAllFromWishlist: PropTypes.func,
    removeFromWishlist: PropTypes.func,
    wishlistItems: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        cartItems: state.cartData,
        wishlistItems: state.wishlistData,
        currency: state.currencyData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (item, quantityCount) => {
            dispatch(addToCart(item, quantityCount));
        },
        removeFromWishlist: (item) => {
            dispatch(removeFromWishlist(item));
        },
        removeAllFromWishlist: () => {
            dispatch(removeAllFromWishlist());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Wishlist);